<form [formGroup]="form" id="rainSystemForm">
      <div>👉 Personalizează-ți sistemului pluvial:</div>
  <mat-form-field appearance="fill" [style.display]="predefinedProducer ? 'none' : undefined">
    <mat-label>Producător</mat-label>
    <mat-select formControlName="producer" (selectionChange)="producerChange()" [required]="true">
      <mat-option value="Bilka">
        <div style="display: flex; align-items: center">
          <img height="40" loading="lazy" src="assets/bilka-logo.svg" />
          <span style="display:none;">Bilka</span>
        </div>
      </mat-option>
      <mat-option value="Wetterbest">
        <div style="display: flex; align-items: center">
          <img height="40" loading="lazy" src="assets/wetterbest-logo.png" />
          <span style="display:none;">Wetterbest</span>
        </div>
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Diametru (Ø)</mat-label>
    <mat-select formControlName="diameter" (selectionChange)="diameterChange()">
      <mat-option *ngFor="let diameter of diameters" [value]="diameter.value">{{ diameter.key }}</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Finisaj</mat-label>
    <mat-select formControlName="finish" (selectionChange)="finishChange()">
      <mat-option *ngFor="let finish of finishes" [value]="finish">
        <div style="display: flex; align-items: center">
          <img *ngIf="form.controls.producer.value === 'Bilka'" height="40" src="{{getImagePath(finish, '8017')}}" />
          <span style="font-size: 16px; margin-left: 10px">{{ finish | titlecase }}</span>
          <span class="new-price" *ngIf="finish === 'SSAB MAT'"> (la preț de lucios)</span>
        </div>
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Culoare</mat-label>
    <mat-select formControlName="color" [required]="true">
      <mat-option *ngFor="let color of colors" [value]="color">
        <div style="display: flex; align-items: center">
          <img height="40" src="{{getImagePath(form.controls.finish.value, color)}}" />
          <span style="font-size: 16px; margin-left: 10px">{{ color | titlecase }}</span>
        </div>
      </mat-option>
    </mat-select>
  </mat-form-field>
</form>
